export const laoHotelSettings: Record<string, string> = {
  'Your room inventory, in one focused view.': 'ເບິ່ງສະຖານະຫ້ອງທັງໝົດໃນມຸມມອງດຽວ',
  'Configure your property, booking sources and daily defaults.':
    'ຕັ້ງຄ່າໂຮງແຮມ, ແຫຼ່ງການຈອງ ແລະ ຄ່າເລີ່ມຕົ້ນ',
  'Property configuration': 'ການຕັ້ງຄ່າໂຮງແຮມ',
  'Settings sections': 'ໝວດການຕັ້ງຄ່າ',
  'Property details': 'ຂໍ້ມູນໂຮງແຮມ',
  'Stay defaults': 'ຄ່າເລີ່ມຕົ້ນການເຂົ້າພັກ',
  'Rooms & types': 'ຫ້ອງ ແລະ ປະເພດຫ້ອງ',
  'Calendar & colors': 'ປະຕິທິນ ແລະ ສີ',
  'Billing & access': 'ການເກັບເງິນ ແລະ ສິດໃຊ້ງານ',
  'Shared across your hotel': 'ໃຊ້ຮ່ວມກັນທົ່ວໂຮງແຮມ',
  'Changes are saved with your name and time in the activity log.':
    'ບັນທຶກການປ່ຽນແປງພ້ອມຊື່ຜູ້ແກ້ໄຂ ແລະ ເວລາໃນປະຫວັດ',
  'You can view settings. Ask a hotel administrator to make changes.':
    'ທ່ານເບິ່ງການຕັ້ງຄ່າໄດ້. ຂໍໃຫ້ຜູ້ດູແລໂຮງແຮມແກ້ໄຂ',
  'Hotel settings saved': 'ບັນທຶກການຕັ້ງຄ່າໂຮງແຮມແລ້ວ',
  'Manage where reservations come from and how each source appears.':
    'ຈັດການແຫຼ່ງທີ່ມາຂອງການຈອງ ແລະ ຮູບແບບການສະແດງ',
  'Track how each reservation reached your hotel.': 'ຕິດຕາມວ່າແຕ່ລະການຈອງມາຈາກແຫຼ່ງໃດ',
  'Add booking source': 'ເພີ່ມແຫຼ່ງການຈອງ',
  'Edit booking source': 'ແກ້ໄຂແຫຼ່ງການຈອງ',
  'Save booking source': 'ບັນທຶກແຫຼ່ງການຈອງ',
  'Booking source saved': 'ບັນທຶກແຫຼ່ງການຈອງແລ້ວ',
  'Booking source added': 'ເພີ່ມແຫຼ່ງການຈອງແລ້ວ',
  'active sources': 'ແຫຼ່ງທີ່ໃຊ້ງານ',
  'online sources': 'ແຫຼ່ງອອນລາຍ',
  'Default source': 'ແຫຼ່ງເລີ່ມຕົ້ນ',
  'Change default': 'ປ່ຽນຄ່າເລີ່ມຕົ້ນ',
  'Search booking sources': 'ຄົ້ນຫາແຫຼ່ງການຈອງ',
  'Source status': 'ສະຖານະແຫຼ່ງການຈອງ',
  'Active sources': 'ແຫຼ່ງທີ່ໃຊ້ງານ',
  'Archived sources': 'ແຫຼ່ງທີ່ຢຸດໃຊ້',
  'All sources': 'ທຸກແຫຼ່ງ',
  'All types': 'ທຸກປະເພດ',
  Archived: 'ຢຸດໃຊ້',
  Commission: 'ຄ່ານາຍໜ້າ',
  'Commission (%)': 'ຄ່ານາຍໜ້າ (%)',
  'Direct booking': 'ຈອງໂດຍກົງ',
  'Online travel agency': 'ຕົວແທນທ່ອງທ່ຽວອອນລາຍ',
  'Search & referral': 'ເວັບຄົ້ນຫາ ແລະ ແຫຼ່ງແນະນຳ',
  Other: 'ອື່ນໆ',
  'Source details': 'ຂໍ້ມູນແຫຼ່ງການຈອງ',
  'Source name': 'ຊື່ແຫຼ່ງການຈອງ',
  'Source type': 'ປະເພດແຫຼ່ງການຈອງ',
  'Fallback color': 'ສີເມື່ອບໍ່ມີໂລໂກ້',
  'Booking source logo': 'ໂລໂກ້ແຫຼ່ງການຈອງ',
  'Available for new reservations': 'ໃຊ້ສຳລັບການຈອງໃໝ່',
  'A recognizable name and logo for reservations and the room calendar.':
    'ຊື່ ແລະ ໂລໂກ້ທີ່ຈຳໄດ້ງ່າຍສຳລັບການຈອງ ແລະ ປະຕິທິນຫ້ອງ',
  'Choose another default in Stay defaults before archiving this source.':
    'ເລືອກແຫຼ່ງເລີ່ມຕົ້ນອື່ນໃນຄ່າເລີ່ມຕົ້ນການເຂົ້າພັກ ກ່ອນຢຸດໃຊ້ແຫຼ່ງນີ້',
  'Turn off to archive. Existing reservations stay linked.':
    'ປິດເພື່ອຢຸດໃຊ້. ການຈອງເກົ່າຍັງເຊື່ອມໂຍງຢູ່',
  'Reload booking sources': 'ໂຫຼດແຫຼ່ງການຈອງຄືນ',
  'No booking sources match': 'ບໍ່ພົບແຫຼ່ງການຈອງທີ່ກົງກັນ',
  'Change the search or source status to see more sources.':
    'ປ່ຽນການຄົ້ນຫາ ຫຼື ສະຖານະເພື່ອເບິ່ງແຫຼ່ງອື່ນ',
  'Commission is a reference rate. It does not deduct from guest folios. Archive a source to stop new bookings; existing reservations keep their source.':
    'ຄ່ານາຍໜ້າເປັນອັດຕາອ້າງອີງ ແລະ ບໍ່ຫັກຈາກບັນຊີແຂກ. ຢຸດໃຊ້ແຫຼ່ງເພື່ອຢຸດການຈອງໃໝ່; ການຈອງເກົ່າຍັງຮັກສາແຫຼ່ງເດີມ',
  'Sources label reservations entered by staff; they do not sync bookings. Commission is a reference rate and does not deduct from guest folios. Archive a source to stop new bookings; existing reservations keep their source.':
    'ແຫຼ່ງການຈອງໃຊ້ລະບຸການຈອງທີ່ພະນັກງານບັນທຶກ; ບໍ່ໄດ້ຊິງຄ໌ການຈອງ. ຄ່ານາຍໜ້າເປັນອັດຕາອ້າງອີງ ແລະ ບໍ່ຫັກຈາກບັນຊີແຂກ. ຢຸດໃຊ້ແຫຼ່ງເພື່ອຢຸດການຈອງໃໝ່; ການຈອງເກົ່າຍັງຮັກສາແຫຼ່ງເດີມ',
  'The hotel identity shown throughout your PMS.': 'ຂໍ້ມູນໂຮງແຮມທີ່ສະແດງໃນລະບົບ PMS',
  'Property logo': 'ໂລໂກ້ໂຮງແຮມ',
  'Property name': 'ຊື່ໂຮງແຮມ',
  'Time zone': 'ເຂດເວລາ',
  'Hotel billing currency': 'ສະກຸນເງິນເກັບຄ່າຫ້ອງ',
  'Lao kip': 'ກີບລາວ',
  'Pre-fill new reservations. Staff can adjust each stay.':
    'ຕື່ມຄ່າເລີ່ມຕົ້ນໃຫ້ການຈອງໃໝ່. ພະນັກງານປັບແຕ່ລະການພັກໄດ້',
  'Standard check-in time': 'ເວລາເຂົ້າພັກມາດຕະຖານ',
  'Standard check-out time': 'ເວລາອອກມາດຕະຖານ',
  'Default nights': 'ຈຳນວນຄືນເລີ່ມຕົ້ນ',
  'Default guest count': 'ຈຳນວນແຂກເລີ່ມຕົ້ນ',
  'Default booking source': 'ແຫຼ່ງການຈອງເລີ່ມຕົ້ນ',
  'Default invoice tax (%)': 'ອັດຕາພາສີໃບແຈ້ງໜີ້ເລີ່ມຕົ້ນ (%)',
  'Standard times are guidance for staff. Check-in and checkout still use the reservation date and existing room and folio checks.':
    'ເວລາມາດຕະຖານເປັນຄຳແນະນຳສຳລັບພະນັກງານ. ການເຂົ້າ ແລະ ອອກຍັງອີງຕາມວັນທີຈອງ ແລະ ການກວດຫ້ອງ ແລະ ບັນຊີແຂກ',
  'Choose the starting view and visual detail for your room calendar.':
    'ເລືອກມຸມມອງເລີ່ມຕົ້ນ ແລະ ລາຍລະອຽດທີ່ສະແດງໃນປະຕິທິນຫ້ອງ',
  'Default calendar window': 'ຊ່ວງປະຕິທິນເລີ່ມຕົ້ນ',
  'Compact rows': 'ແຖວກະທັດຮັດ',
  'Fit more rooms into the calendar.': 'ສະແດງຫ້ອງໄດ້ຫຼາຍຂຶ້ນໃນປະຕິທິນ',
  'Show nightly rates': 'ສະແດງລາຄາຕໍ່ຄືນ',
  'Display room prices in empty dates.': 'ສະແດງລາຄາຫ້ອງຕາມວັນທີ',
  'Show booking sources': 'ສະແດງແຫຼ່ງການຈອງ',
  'Show source names and logos on reservation bars.': 'ສະແດງຊື່ ແລະ ໂລໂກ້ແຫຼ່ງການຈອງເທິງແຖບການພັກ',
  'Make reservation, deposit and housekeeping statuses easy to recognize.':
    'ເຮັດໃຫ້ສະຖານະການຈອງ, ມັດຈຳ ແລະ ເຮັດຄວາມສະອາດຈຳໄດ້ງ່າຍ',
  'Edit status colors': 'ແກ້ໄຂສີສະຖານະ',
  'All changes saved': 'ບັນທຶກທຸກການປ່ຽນແປງແລ້ວ',
  'Unsaved changes': 'ການປ່ຽນແປງທີ່ຍັງບໍ່ບັນທຶກ',
  'Discard changes': 'ຍົກເລີກການປ່ຽນແປງ',
  'Reload saved settings': 'ໂຫຼດການຕັ້ງຄ່າທີ່ບັນທຶກຄືນ',
  'Unsaved property settings': 'ການຕັ້ງຄ່າໂຮງແຮມທີ່ຍັງບໍ່ບັນທຶກ',
  'Review changes': 'ກວດການປ່ຽນແປງ',
  'Edit room': 'ແກ້ໄຂຫ້ອງ',
  'Save room': 'ບັນທຶກຫ້ອງ',
  'Room updated': 'ປັບປຸງຫ້ອງແລ້ວ',
  'Manage room identity, floor, capacity and the base nightly rate.':
    'ຈັດການເລກຫ້ອງ, ຊັ້ນ, ຄວາມຈຸ ແລະ ລາຄາພື້ນຖານຕໍ່ຄືນ',
  'room types': 'ປະເພດຫ້ອງ',
  floors: 'ຊັ້ນ',
  'Search room, type or floor': 'ຄົ້ນຫາຫ້ອງ, ປະເພດ ຫຼື ຊັ້ນ',
  'Base nightly rate': 'ລາຄາພື້ນຖານຕໍ່ຄືນ',
  'Room edits preserve agreed reservation prices. Manage room readiness in Housekeeping and dated prices in the availability matrix.':
    'ການແກ້ໄຂຫ້ອງຮັກສາລາຄາການຈອງເດີມ. ຈັດການຄວາມພ້ອມໃນການເຮັດຄວາມສະອາດ ແລະ ລາຄາຕາມວັນທີໃນຕາຕະລາງຫ້ອງຫວ່າງ',
  'Manage hotel pricing and permissions in their connected areas.':
    'ຈັດການລາຄາ ແລະ ສິດໃຊ້ງານໃນໝວດທີ່ເຊື່ອມໂຍງ',
  'Manage rate plans, nightly prices and booking restrictions.':
    'ຈັດການແຜນລາຄາ, ລາຄາຕໍ່ຄືນ ແລະ ຂໍ້ຈຳກັດການຈອງ',
  'Company & billing details': 'ຂໍ້ມູນບໍລິສັດ ແລະ ການເກັບເງິນ',
  'Manage the company details used on LFB invoices.': 'ຈັດການຂໍ້ມູນບໍລິສັດທີ່ໃຊ້ໃນໃບແຈ້ງໜີ້ LFB',
  'Roles & permissions': 'ບົດບາດ ແລະ ສິດໃຊ້ງານ',
  'Control who can configure, book, edit and export hotel records.':
    'ກຳນົດຜູ້ທີ່ສາມາດຕັ້ງຄ່າ, ຈອງ, ແກ້ໄຂ ແລະ ສົ່ງອອກຂໍ້ມູນໂຮງແຮມ',
  'Review property changes with actor, time and change details.':
    'ກວດການປ່ຽນແປງພ້ອມຜູ້ແກ້ໄຂ, ເວລາ ແລະ ລາຍລະອຽດ',
};
